import React from "react";
import myimg from "../../../assets/images/group.png";

const frontPicture = () => {
  return (
    <>
      <div className="picture-title text-center">Front Pictures</div>
      <div className="front-picture-licence ">
        <img src={myimg} className="myimg" alt="front-picutre" />
      </div>
    </>
  );
};

export default frontPicture;
